import React, { useState } from "react"
import { Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"
import { maskEmail, maskPhoneNumber } from "../../../../common/functions"
import { useSelector } from "react-redux"
import { BackButton, verifyEmailSmallIcon, verifyPhoneSmallIcon } from "../../../Common/SvgIcons"
import config from "../../../../config"


const TryOtherOptionsLayout = props => {
    const loginState = useSelector(state => state.Login)
    const { email, cmp_phone, dailcode } = loginState
    const { supportEmail } = config.messages

    const handleClicksend = (from) => {
        props.setSendingFrom(from)
    }


    return (
        <div className="auth-form-container">
            <Card>
                <CardBody>
                    <div className="Try-other-options-container">
                        <div className="title">
                            <div className="close-icon" onClick={props?.handleBackClick}>{BackButton}</div>

                            <span >Choose verification method</span>
                        </div>
                        <div className="option-container">
                            <div className="left-container">
                                {verifyEmailSmallIcon}
                                <div className="details-container">
                                    <span className="title">Send code to email</span>
                                    <span className="subtitle">{maskEmail(email)}</span>
                                </div>
                            </div>
                            <div className={`send-button ${props?.sendEmailLoading ? "disabled" : ""}`} onClick={() => {
                                if (!props?.sendEmailLoading) {
                                    handleClicksend("other-email")

                                }
                            }

                            }>
                                Send
                                {
                                    props?.sendEmailLoading &&
                                    <div className="spinner-container spinner-border">
                                    </div>
                                }

                            </div>
                        </div>
                        <div className="option-container">
                            <div className="left-container">
                                {verifyPhoneSmallIcon}
                                <div className="details-container">
                                    <span className="title">Send code to phone</span>
                                    <span className="subtitle">{dailcode} {maskPhoneNumber(cmp_phone)}</span>
                                </div>
                            </div>
                            <div className={`send-button ${props?.sendPhoneLoading ? "disabled" : ""}`} onClick={() => {
                                if (!props?.sendPhoneLoading) {
                                    handleClicksend("other-phone")

                                }
                            }

                            }>
                                Send
                                {
                                    props?.sendPhoneLoading &&
                                    <div className="spinner-container spinner-border">
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="option-container">
                            <span className="support-text">Having trouble with verification? Reach out to our <a className="support-link" href={`mailto:${supportEmail}`}>support team</a> for assistance.</span>

                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default TryOtherOptionsLayout

TryOtherOptionsLayout.propTypes = {
    title: PropTypes.string,
    imgsrc: PropTypes.string,
    layout: PropTypes.any,
}
